import React from 'react';
import { motion } from 'framer-motion';

const TEMPLATES = [
  { id: 'romance-rose', name: 'Romance Rose', emoji: '🌹', color: 'from-rose-100 to-pink-200', free: true },
  { id: 'midnight-love', name: 'Midnight Love', emoji: '🌙', color: 'from-indigo-100 to-purple-200', free: true },
  { id: 'garden-bloom', name: 'Garden Bloom', emoji: '🌸', color: 'from-pink-100 to-fuchsia-100', free: true },
  { id: 'candlelight', name: 'Candlelight', emoji: '🕯️', color: 'from-amber-100 to-orange-100', free: true },
  { id: 'eternal-love', name: 'Eternal Love', emoji: '💎', color: 'from-violet-100 to-purple-200', free: false },
  { id: 'paris-nights', name: 'Paris Nights', emoji: '🗼', color: 'from-slate-100 to-gray-200', free: false },
];

const CouplesTemplate = ({ data, onNext }) => {
  return (
    <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} className="p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-1">Choose an Envelope 💌</h2>
      <p className="text-gray-500 text-sm mb-6">Pick a romantic style for your love card</p>

      <div className="grid grid-cols-2 gap-4">
        {TEMPLATES.map((t, idx) => (
          <motion.button
            key={t.id}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: idx * 0.05 }}
            onClick={() => onNext({ templateId: t.id, templateName: t.name })}
            className={`relative p-5 rounded-2xl flex flex-col items-center gap-3 border-2 transition-all
              ${data.templateId === t.id
                ? 'border-purple-500 bg-purple-50 shadow-lg'
                : 'border-transparent bg-white shadow-sm hover:shadow-md hover:border-purple-200'}`}
          >
            {!t.free && (
              <span className="absolute top-2 right-2 text-[10px] font-bold bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">PRO</span>
            )}
            <div className={`w-16 h-20 bg-gradient-to-b ${t.color} rounded-xl flex items-center justify-center shadow-inner`}>
              <span className="text-3xl">{t.emoji}</span>
            </div>
            <span className="font-medium text-xs text-gray-700 text-center">{t.name}</span>
          </motion.button>
        ))}
      </div>
    </motion.div>
  );
};

export default CouplesTemplate;